import React from "react";
import { Link } from "react-router-dom";

function Services({ language = "en" }) {
  const services = [
    {
  id: "featured",
  title: {
   en: "Feasibility Study Services",
    ar: "خدمات دراسات الجدوى",
  },
  description: {
     en: "We provide comprehensive feasibility studies that help investors and organizations evaluate project viability, reduce risks, and make informed strategic decisions.",
    ar: "نقدّم دراسات جدوى شاملة تساعد المستثمرين والمنظمات على تقييم جدوى المشاريع وتقليل المخاطر واتخاذ قرارات استراتيجية مدروسة",
  },
   path: "/feasibility", // ✅ نفس النافبار
  featured: true,
},
    {
      id: "management",
      title: {
        en: "Management Consulting Services",
        ar: "خدمات الاستشارات الإدارية",
      },
      description: {
        en: "Al-Jabriyah Management Consulting provides strategic advisory services that empower organizations to enhance performance and achieve sustainable growth.",
        ar: "تقدّم الجبرية للاستشارات الإدارية خدمات استشارية استراتيجية تمكّن المنظمات من تحسين أدائها وتحقيق نمو مستدام",
      },
      path: "/services/management",
    },
    {
      id: "event",
      title: {
        en: "Event Management Marketing Solutions",
        ar: "حلول إدارة الفعاليات والتسويق",
      },
      description: {
        en: "Al-Jabriyah offers comprehensive Event Management and Marketing Solutions that help organizations elevate their brand presence and achieve impactful market visibility.",
        ar: "توفر الجبرية حلولاً متكاملة لإدارة الفعاليات والتسويق لمساعدة المنظمات على تعزيز حضورها وتحقيق تأثير قوي في السوق",
      },
      path: "/services/event",
    },
    {
      id: "business",
      title: {
        en: "Business Development Consulting Service",
        ar: "خدمات تطوير الأعمال",
      },
      description: {
        en: "Al-Jabriyah offers comprehensive Business Development Services designed to support organizations in achieving sustainable growth and market expansion.",
        ar: "توفّر الجبرية خدمات تطوير أعمال شاملة لدعم المنظمات في تحقيق نمو مستدام وتوسّع مدروس في الأسواق",
      },
      path: "/services/business",
    },
    {
      id: "it",
      title: {
        en: "Low Current-IT Services Apply And Supply",
        ar: "خدمات التيار الضعيف وتقنية المعلومات",
      },
      description: {
        en: "Al-Jabriyah delivers comprehensive IT Services and Solutions designed to help organizations transform digitally and achieve sustainable growth.",
        ar: "تقدّم الجبرية حلول وخدمات تقنية معلومات متكاملة، بما في ذلك أنظمة التيار الضعيف، لمساعدة المنظمات على التحوّل الرقمي وتحقيق نمو مستدام",
      },
      path: "/services/it",
    },
  ];

  return (
    <section className="services-section" id="services">
      <h2 className="services-title">
        {language === "ar" ? "خدمات" : "OUR "}
        <span>{language === "ar" ? "نا" : "SERVICES"}</span>
      </h2>

      <p className="services-desc">
        {language === "ar"
          ? "تقدّم الجبرية حلول أعمال متكاملة عبر عدة قطاعات، معتمدة على خبرة تمتد لعقود لدعم النمو والابتكار"
          : "Al-Jabriyah offers comprehensive business solutions across multiple sectors, leveraging decades of expertise to drive growth and innovation."}
      </p>

     {/* الكرت المميز */}
<div className="featured-wrapper">
  {services
    .filter((s) => s.featured)
    .map((service) => (
      <article key={service.id} className="service-card featured">
        <div className="icon-wrap">
          <svg viewBox="0 0 64 64" className="icon-circle">
            <circle cx="32" cy="32" r="30" fill="#e44339" />
            <polygon
              points="32,16 36.6,27.5 48.8,27.5 38.1,34.8 42.7,46.3 32,38.6 21.3,46.3 25.9,34.8 15.2,27.5 27.4,27.5"
              fill="#FFD700" // ⭐ ذهبية
            />
          </svg>
        </div>

        <Link to={service.path} className="service-link">
          <h3>{service.title[language]}</h3>
        </Link>

        <p className="card-text">{service.description[language]}</p>

        <Link to={service.path} className="read-more">
          {language === "ar" ? "المزيد" : "Read more"}
        </Link>
      </article>
    ))}
</div>

{/* باقي الكروت */}
<div className="services-grid">
  {services
    .filter((s) => !s.featured)
    .map((service) => (
      <article key={service.id} className="service-card">
        <div className="icon-wrap">
          <svg viewBox="0 0 64 64" className="icon-circle">
            <circle cx="32" cy="32" r="30" fill="#e44339" />
            <polygon
              points="32,16 36.6,27.5 48.8,27.5 38.1,34.8 42.7,46.3 32,38.6 21.3,46.3 25.9,34.8 15.2,27.5 27.4,27.5"
              fill="#3f2f78"
            />
          </svg>
        </div>

        <Link to={service.path} className="service-link">
          <h3>{service.title[language]}</h3>
        </Link>

        <p className="card-text">{service.description[language]}</p>

        <Link to={service.path} className="read-more">
          {language === "ar" ? "المزيد" : "Read more"}
        </Link>
      </article>
    ))}
</div>
    </section>
  );
}

export default Services;
